<template>
  <div class="topbar">
    <button @click="$root.showSidebar = !$root.showSidebar">
      <div class="md-icon">menu</div>
    </button>
    <div class="main-content" @click="openHome">MindScrib</div>
    <template v-if="selection.length">
      <button
        v-if="selection.insertMode && !settings.implicitInsert"
        @click.stop="selection.insertMode = false"
      >
        <div class="md-icon">clear</div>
        anuluj
      </button>
      <button v-else @click.stop="selection.clear">
        <div class="md-icon">clear</div>
        odznacz ({{ selection.length }})
      </button>
    </template>
    <button ref="menubtn" @click="openMenu">
      <div class="md-icon">account_circle</div>
    </button>
  </div>
</template>

<style scoped>
.topbar {
  flex: 48px 0 0;
  padding: 0 var(--basic-padding);
  display: flex;
  gap: calc(2 * var(--basic-gap));
  align-items: center;
  color: var(--text-color-primary);
  background: var(--bg-color-topbar);
  border-bottom: var(--topbar-border);
}
.topbar .md-icon {
  opacity: var(--icon-opacity-topbar);
}
.selectionMode .topbar {
  background: var(--bg-color-topbar-selection);
}
.main-content {
  flex: auto;
  display: flex;
  gap: calc(2 * var(--basic-gap));
  align-items: center;
  font-size: 20px;
  height: 100%;
  cursor: pointer;
  user-select: none;
}
button {
  height: var(--indent-size);
  min-width: var(--indent-size);
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
  color: var(--text-color-primary);
}
</style>

<script>
import router from "@/router";
import selection from "@/selection";
import settings from "@/synced-settings";

export default {
  components: {},
  data() {
    return {
      selection: selection,
      settings: settings,
    };
  },
  computed: {},
  methods: {
    openMenu(event) {
      const button = this.$refs.menubtn.getBoundingClientRect();
      this.$root.$emit("account-menu", { button });
    },
    openHome() {
      router.safePush(settings.homeView);
    },
  },
};
</script>
